import { Box, Spinner, Text, useColorModeValue } from "@chakra-ui/react";

interface LoadingProps {
  spinnerSize?: string; // Tamanho do Spinner (por exemplo, "xl")
}

const LoadingComponent: React.FC<LoadingProps> = ({
  spinnerSize = "100vh",
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height={spinnerSize}
    >
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="xl"
      />
      <Text marginTop="4" fontSize="xl" fontWeight="bold">
        Buscando dados
      </Text>
    </Box>
  );
};

export default LoadingComponent;
